import React from "react";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import PlannedTournamentApi from "../api/plannedTournamentApi";
import PlannedTournamentEdit from "./plannedTournamentEdit";
import PlannedTournamentView from "./plannedTournamentView";

class PlannedTournament extends React.Component {
  state = {
    isLoading: true,
    isEditMode: true,

    processing: false,

    plannedTournament: {
      plannedTournamentId: "",
      state: "",
      name: "",
      date: "",
      startTime: "",
      endTime: "",
      eventInfoId: "",
      scoringFormatId: "",
      eventVisibilityId: "",
      courtInfo: "",
      registrations: [],
      registrationUrl: "",
      isRegistrationOpen: false,
      canStart: false,
      canDelete: false,
    },
  };

  async componentDidMount() {
    const { plannedTournamentId } = this.props;

    if (!plannedTournamentId) {
      this.setState({
        isLoading: false,
        isEditMode: true,
      });
      return;
    }

    this.setState({ processing: true });

    const {
      success,
      data: {
        state,
        name,
        date,
        startTime,
        endTime,
        eventInfoId,
        scoringFormatId,
        eventVisibilityId,
        courtInfo,
        registrations,
        registrationUrl,
        isRegistrationOpen,
        canStart,
        canDelete,
      },
      message,
    } = await PlannedTournamentApi.getOne(plannedTournamentId);

    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    this.setState({
      isLoading: false,
      isEditMode: false,
      processing: false,
      plannedTournament: {
        plannedTournamentId,
        state,
        name,
        date,
        startTime,
        endTime,
        eventInfoId,
        scoringFormatId,
        eventVisibilityId,
        courtInfo,
        registrations,
        registrationUrl,
        isRegistrationOpen,
        canStart,
        canDelete,
      },
    });
  }

  handleSubmit = async (plannedTournament) => {
    this.setState({ processing: true });

    const { success, data, message } = await PlannedTournamentApi.setOne(plannedTournament);

    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    if (!this.props.plannedTournamentId) {
      window.location.replace(`${process.env.PUBLIC_URL}/?planned=${data.plannedTournamentId}`);
    } else {
      this.setState({ isEditMode: false, plannedTournament: data, processing: false });
      toast.success("Planned Tournament saved");
    }
  };

  handleDelete = async () => {
    const { plannedTournamentId } = this.state.plannedTournament;

    this.setState({ processing: true });

    const { success, message } = await PlannedTournamentApi.delete(plannedTournamentId);

    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    this.setState({
      plannedTournament: {
        plannedTournamentId: "",
        state: "",
        name: "",
        date: "",
        startTime: "",
        endTime: "",
        eventInfoId: "",
        scoringFormatId: "",
        eventVisibilityId: "",
        courtInfo: { "-1": "" },
        registrations: [],
        isRegistrationOpen: false,
        canStart: false,
        canDelete: false,
      },
      processing: false,
    });
    toast.success("Planned Tournament deleted");
    window.location.replace(`${process.env.PUBLIC_URL}/?planned=all`);
  };

  handleCloseRegistration = async () => {
    const { plannedTournamentId } = this.state.plannedTournament;

    this.setState({ processing: true });

    const { success, data, message } = await PlannedTournamentApi.closeRegistration(plannedTournamentId);

    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    this.setState({ plannedTournament: data, processing: false });
    toast.success("Registration is now closed");
  };

  handleOpenRegistration = async () => {
    const { plannedTournamentId } = this.state.plannedTournament;

    this.setState({ processing: true });

    const { success, data, message } = await PlannedTournamentApi.openRegistration(plannedTournamentId);

    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    this.setState({ plannedTournament: data, processing: false });
    toast.success("Registration is now open");
  };

  handleMakeEven = async () => {
    const { plannedTournamentId } = this.state.plannedTournament;

    this.setState({ processing: true });

    const { success, data, message } = await PlannedTournamentApi.makeEven(plannedTournamentId);

    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    this.setState({ plannedTournament: data, processing: false });
    toast.success("Registrations were evened out");
  };

  handleUnregister = async (plannedEventRegistrationId) => {
    const { plannedTournamentId } = this.state.plannedTournament;

    this.setState({ processing: true });

    const { success, data, message } = await PlannedTournamentApi.unregister(plannedTournamentId, plannedEventRegistrationId);

    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    this.setState({ plannedTournament: data, processing: false });
    toast.success("Registration removed");
  };

  handleStart = async () => {
    const { plannedTournamentId } = this.state.plannedTournament;

    this.setState({ processing: true });

    const { success, message } = await PlannedTournamentApi.start(plannedTournamentId);

    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    this.setState({ processing: false });
    toast.success("Tournament started");
    window.location.replace(`${process.env.PUBLIC_URL}/?planned=all`);
  };

  handleEdit = () => {
    this.setState({ isEditMode: true });
  };

  handleCancel = () => {
    const { plannedTournamentId } = this.props;

    if (!plannedTournamentId) {
      window.location.replace(`${process.env.PUBLIC_URL}/?planned=all`);
      return;
    }

    this.setState({ isEditMode: false });
  };

  handleTierChange = async (plannedEventRegistrationId, tierId) => {
    const { plannedTournamentId } = this.state.plannedTournament;

    this.setState({ processing: true });

    const { success, data, message } = await PlannedTournamentApi.setTier(plannedTournamentId, plannedEventRegistrationId, tierId);

    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    this.setState({ plannedTournament: data, processing: false });
    toast.success("Tier set");
  };

  render() {
    const { isLoading, isEditMode, plannedTournament, processing } = this.state;
    const { staticData } = this.props;

    return (
      <React.Fragment>
        <Modal show={processing} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Body>Processing...</Modal.Body>
        </Modal>
        {!isLoading && !isEditMode && (
          <PlannedTournamentView
            handleCloseRegistration={this.handleCloseRegistration}
            handleOpenRegistration={this.handleOpenRegistration}
            handleUnregister={this.handleUnregister}
            handleStart={this.handleStart}
            handleEdit={this.handleEdit}
            handleMakeEven={this.handleMakeEven}
            handleTierChange={this.handleTierChange}
            plannedTournament={plannedTournament}
            staticData={staticData}
          />
        )}
        {!isLoading && isEditMode && (
          <PlannedTournamentEdit
            plannedTournament={plannedTournament}
            staticData={staticData}
            handleSubmit={this.handleSubmit}
            handleCancel={this.handleCancel}
          />
        )}
      </React.Fragment>
    );
  }
}

export default PlannedTournament;
